import React from "react";

import { useUserState } from "contexts/user";

import UploadLogo from "./UploadLogo";

import AppRouteGenerator from "../AppRouteGenerator";

const Settings = ({ features }) => {
  const CLIENT_ROUTES = {
    "Upload Logo": {
      component: UploadLogo,
      path: "logo",
    },
  };

  const user = useUserState();

  return (
    <AppRouteGenerator
      CLIENT_ROUTES={CLIENT_ROUTES}
      features={features}
      user={user}
    />
  );
};

export default Settings;
